module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows-52e33bcb6aa504aa9bd739aaa80c9d84.png";